module.exports = __webpack_public_path__ + "img/fundingProtectLogo2.2442b047.png";